import styled from "styled-components";

export const LogoWrapper = styled.div`
    width: auto;
    height: 6rem;
    img {
      width: 100%;
      height: 100%;
    }
`;